import React from 'react';
import styled from 'astroturf/react';
import { Placement } from '@floating-ui/react';
import { Menu } from 'js/design_system/Menu';
import { MenuItem as MenuItemBase } from 'js/design_system/MenuItem';
import { MultiDotMore } from 'js/social/shared/Icons';
import { Button } from 'js/social/shared/design_system/Button';
import { ImpressionProps } from 'js/utils/impressions';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';
import _MenuItemContainer from "SocialActionsMenu-MenuItemContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Menu/SocialActionsMenu.tsx?styleId=MenuItemContainer";
import _MenuItemInfo from "SocialActionsMenu-MenuItemInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Menu/SocialActionsMenu.tsx?styleId=MenuItemInfo";
import _MenuItemText from "SocialActionsMenu-MenuItemText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Menu/SocialActionsMenu.tsx?styleId=MenuItemText";
import _MenuItemSubtext from "SocialActionsMenu-MenuItemSubtext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Menu/SocialActionsMenu.tsx?styleId=MenuItemSubtext";


const MenuItemContainer = /*#__PURE__*/styled(MenuItemBase, null, {
  displayName: "MenuItemContainer",
  styles: _MenuItemContainer
});

const MenuItemInfo = /*#__PURE__*/styled("div", null, {
  displayName: "MenuItemInfo",
  styles: _MenuItemInfo
});

const MenuItemText = /*#__PURE__*/styled("div", null, {
  displayName: "MenuItemText",
  styles: _MenuItemText
});

const MenuItemSubtext = /*#__PURE__*/styled("div", null, {
  displayName: "MenuItemSubtext",
  styles: _MenuItemSubtext
});

type MenuItemProps = {
  showItem: boolean;
  itemIcon?: JSX.Element;
  itemText: string;
  itemSubtext?: string;
  onClick: () => void;
  impressionProps?: ImpressionProps;
};

type MenuProps = {
  placement: Placement;
  menuItems: MenuItemProps[];
  buttonClassName?: string;
};

export const MenuItem: React.FunctionComponent<MenuItemProps> = ({
  showItem,
  itemIcon,
  itemText,
  itemSubtext,
  onClick,
}) =>
  showItem ? (
    <MenuItemContainer onClick={onClick}>
      {itemIcon}
      <MenuItemInfo>
        <MenuItemText>{itemText}</MenuItemText>
        <MenuItemSubtext>{itemSubtext}</MenuItemSubtext>
      </MenuItemInfo>
    </MenuItemContainer>
  ) : null;

export const SocialActionsMenu: React.FunctionComponent<MenuProps> = ({
  placement,
  menuItems,
  buttonClassName,
}) => {
  const items = menuItems
    .map((menuItem) =>
      menuItem.impressionProps && menuItem.showItem ? (
        <ImpressionWatcher
          key={menuItem.itemText}
          stopPropagation={false}
          {...menuItem.impressionProps}
        >
          <MenuItem {...menuItem} />
        </ImpressionWatcher>
      ) : (
        <MenuItem key={menuItem.itemText} {...menuItem} />
      ),
    )
    .filter((element: any) => !!element);

  if (items.length <= 0) return null;

  return (
    <div>
      <Menu placement={placement} render={() => <>{items}</>}>
        <Button
          variant="text-gray"
          icon={<MultiDotMore />}
          className={buttonClassName}
        />
      </Menu>
    </div>
  );
};
